import { observer } from 'mobx-react-lite';

import { IcTranslate16Icon } from '@gem/icons';
import { IconView } from '@gem/ui-kit';

import { usePresenter } from './presenter';
import styles from './styles.m.css';

const ArticleTranslate = ({ message }) => {
  const presenter = usePresenter({ message });

  if (!presenter.isShow) {
    return null;
  }

  return (
    <div className={styles.container}>
      <IconView
        Icon={IcTranslate16Icon}
        className={styles.icon}
        size={'small'}
      />

      {presenter.isShowLabel && <span className={styles.label}>{presenter.label}</span>}

      {presenter.isShowButton && (
        <button
          className={styles.button}
          onClick={presenter.onTranslate}
        >
          {presenter.buttonLabel}
        </button>
      )}
    </div>
  );
};

export default observer(ArticleTranslate);
